import { FC } from "react";
import { StyleProp, ViewStyle } from "react-native";
import { ClipPath, Color, Defs, G, Path, Svg } from "react-native-svg";

const PdAlert: FC<{ style?: StyleProp<ViewStyle>; color?: Color }> = ({ style = { height: 18, width: 18 }, color }) => {
  return (
    <Svg style={style} viewBox="0 0 14 14" fill="none">
      <G clipPath="url(#pdalert)" fill={color || "#000"}>
        <Path d="M13.777 10.811 8.425 1.543A1.63 1.63 0 0 0 7 .72a1.63 1.63 0 0 0-1.426.823L.223 10.81a1.63 1.63 0 0 0 0 1.646c.298.516.83.823 1.426.823H12.35a1.63 1.63 0 0 0 1.426-.823 1.63 1.63 0 0 0 0-1.646Zm-.71 1.236a.818.818 0 0 1-.716.413H1.649a.818.818 0 0 1-.716-.413.818.818 0 0 1 0-.826l5.351-9.268A.818.818 0 0 1 7 1.54c.298 0 .566.154.715.413l5.351 9.268c.15.259.15.568 0 .826Z" />
        <Path d="M7.41 4.813h-.82v4.1h.82v-4.1ZM7 9.734a.547.547 0 1 0 .001 1.095.547.547 0 0 0 0-1.095Z" />
      </G>
      <Defs>
        <ClipPath id="pdalert">
          <Path fill={color || "#000"} d="M0 0h14v14H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

export default PdAlert;
